export const postReplyStyles = {
  container: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    gap: '16px',
    justifyContent: 'flex-start',
  },
  gap: {
    marginTop: '20px',
  },
  profileContainer: { display: 'flex', alignItems: 'flex-start', height: '40px', width: '40px' },
  customAvatar: {
    width: '40px',
    height: '40px',
    borderRadius: '8px',
  },
  defaultAvatarContainer: {
    display: 'flex',
    backgroundColor: '#EDEFF7',
    borderRadius: '8px',
    width: '40px',
    height: '40px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  defaultAvatar: {
    fontFamily: 'Inter',
    color: '#6E707A',
    fontSize: '14px',
    fontStyle: 'normal',
    lineHeight: '146%',
    fontWeight: '500',
    '-webkit-user-select': 'none',
    '-ms-user-select': 'none',
    'user-select': 'none',
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: 'calc(100% - 40px - 16px)',
  },
  actionsContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
  },
  attachmentsBtnsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '12px',
    justifyContent: 'flex-start',
    label: {
      backgroundColor: '#FFFFFF',
      border: '1px solid #EDEFF7',
      borderRadius: '8px',
      padding: '5px',
      '& svg': {
        width: '24px',
        height: '24px',
      },
    },
  },
  actionBtnsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    gap: '12px',
  },
  cancelBtn: {
    display: 'flex',
    padding: '8px 12px',
    borderRadius: '8px',
    transition: '300ms',
    fontFamily: 'Inter',
    fontStyles: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    backgroundColor: '#FFFFFF',
    color: '#4D6EF5',
    textTransform: 'unset',
    height: '36px',
    border: '1px solid #4D6EF5',
    cursor: 'pointer',
  },
  submitBtn: {
    display: 'flex',
    padding: '8px 12px',
    borderRadius: '8px',
    transition: '300ms',
    fontFamily: 'Inter',
    backgroundColor: ' #4D6EF5',
    fontStyles: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#FFFFFF',
    textTransform: 'unset',
    height: '36px',
    border: '1px solid #4d6ef5',
    cursor: 'pointer',
    '&:hover': {
      color: '#4d6ef5',
    },
  },
  imagesContainer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
    flexDirection: 'row',
  },
  image: {
    width: '64px',
    height: '64px',
    objectFit: 'contain',
    borderRadius: '8px',
    cursor: 'pointer',
    border: '1px solid #F3F4F9',
  },
};
